/**
 * estamos no meio da refatoração do grid de itens para react
 * durante esta refatoração é desejável que alguns comportamentos atuais do sistema se mantenham,
 * para que possamos evoluir o produto enquanto a refatoração acontece
 *
 * este arquivo exporta um simples booleano que deve ser usado
 */

declare var window:any

const modificacoesDaRefatoracaoAtivadas = true

window.modificacoesDaRefatoracaoAtivadas = modificacoesDaRefatoracaoAtivadas

export {modificacoesDaRefatoracaoAtivadas}
